import React from 'react';
import PropTypes from 'prop-types';
import IconCardWrapper, { IconWrapper, TitleArea } from './IconCard.style';
import * as icons from "react-icons/fa";
import Image from 'components/UI/Image/Image';
import { getIconeUrlById } from 'library/helpers/fonction';

const IconCard = ({ icon, title, align, className }) => {
  // Add all classs to an array
  const addAllClasses = ['icon_card'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }
  ; 
  //const Icon = icon ? icons[icon] : null;

  return (
    <IconCardWrapper className={addAllClasses.join(' ')} align={align}>
      {/* {icon && <Icon/></IconWrapper>} */}
      {icon && <IconWrapper  className="icon_card center-item"><Image width={25} alt={title} src={getIconeUrlById(icon)}/></IconWrapper>}
      {title && <TitleArea className="title-area center-item icon_card">{title}</TitleArea>}
    </IconCardWrapper>
  );
};

IconCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.element,
};

export default IconCard;
